import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  baseUrl = environment.baseUrl;
   users_added_form: FormGroup = new FormGroup({
    id: new FormControl(null),
    property_id: new FormControl('', [Validators.required]),
    name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required, Validators.minLength(8)]),
    role: new FormControl('', [Validators.required]),
    status: new FormControl('', [Validators.required]),
  });

  constructor(private http:HttpClient,
    private datePipe: DatePipe,) { }

    get_users() {
      return this.http.get(this.baseUrl + '/get_users');  
    }
  
    populateForm(rowData: any){
      rowData.status = String(rowData.status);
      this.users_added_form.setValue(_.omit(rowData, 'company_id', 'email_verified_at',
       'remember_token', 'user_id', 'created_at', 'updated_at'));
    }
  
    insert_users_details(formData: any)
    { 
      return this.http.post(this.baseUrl + '/create_user',{
        property_id : formData.property_id,
        name : formData.name,
        email : formData.email,
        password : formData.password,
        role : formData.role,
        status : formData.status,
      });
    }
  
    update_users_details(formData: any)
    { 
      return this.http.post(this.baseUrl + '/update_user',{
        id : formData.id,
        property_id : formData.property_id,
        name : formData.name,
        email : formData.email,
        password : formData.password,
        role : formData.role,
        status : formData.status,
      });
    }

}
